import { useEffect, useState } from "react";

/**
 * Değeri `delay` ms boyunca sabit kaldıktan sonra yansıtır.
 * Arama kutusu → API/filtre zincirinde gereksiz iş yapmayı engeller.
 */
export default function useDebounce(value, delay = 300) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);

  return debounced;
}
